export async function useFetchProxy<T>(url: string, payload: any): Promise<T> {
  payload.watch = false
  const response = await useFetch<T>(url, payload)
  return response.data.value as T
}
